import { Component } from 'react'

const STORAGE_KEY = 'innomatic.chunkReloadedAt'

const isChunkLoadError = (err) => {
  if (!err) return false
  const msg = String(err?.message || err)
  return (
    err.name === 'ChunkLoadError' ||
    /Loading chunk [\d]+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  )
}

export default class ChunkErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return
    // Evita bucles de recarga si el problema persiste.
    const last = Number(sessionStorage.getItem(STORAGE_KEY) || 0)
    const now = Date.now()
    if (now - last < 15_000) return
    sessionStorage.setItem(STORAGE_KEY, String(now))
    window.location.reload()
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    if (isChunkLoadError(error)) {
      return (
        <div className="flex min-h-[60vh] items-center justify-center p-6 text-center text-sm text-muted-foreground">
          Actualizando versión…
        </div>
      )
    }

    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-2 p-6 text-center">
        <p className="text-lg font-semibold">Algo ha fallado</p>
        <p className="text-sm text-muted-foreground">
          {String(error?.message || error)}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
        >
          Recargar
        </button>
      </div>
    )
  }
}
